import {createAction} from 'redux-act';

/*------------------------------------------------------------------------------
Action Creators
------------------------------------------------------------------------------*/

export const updateFeedFilter = createAction('DASHBOARD_RIGHT_PANE_FEED_FILTER_UPDATED');
